export const TasksByUserConfig = {
    name            : 'Tasks by user',
    icon            : 'i5-task-by-user',
    image           : 'tasks-by-user',
    iconSvg         : 'isvg-view-tasks-by-user',
    url             : 'tasks-by-user',
    description     : 'All tasks with filters by action required or assigned to user.',
    canBeInProject  : true,
}

export const CUSTOM_VIEW_TASKS_BY_USER_CONFIG = {
    ...TasksByUserConfig,
    // key2: "newValue2",  // Replacing the value for key2
}